import { cn } from 'src/lib/utils';
import { ToolbarEditor } from 'src/components/ui/editor/ui/toolbar-editor';
import { ComponentProps } from 'react';

export function FixedToolbar(props: ComponentProps<typeof ToolbarEditor>) {
  return (
    <ToolbarEditor
      {...props}
      className={cn(
        'bg-light scrollbar-hide sticky top-0 left-0 z-50 w-full justify-between overflow-x-auto rounded-t-sm-5 border-b border-b-border p-1 backdrop-blur-sm supports-backdrop-blur:bg-background/60',
        props.className,
      )}
    />
  );
}
